import { useCallback } from 'react';

import { useBrazeContext } from 'state/braze';
import { useLDContext } from 'state/launchdarkly';
import { useMParticleContext } from 'state/mParticle';
import ReactAppboy from 'utils/appboy';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { setUserId: brazeSetUserId } = useBrazeContext();
  const { login: launchDarklyLogin, logout: launchDarklyLogout } = useLDContext();
  const { login: mParticleLogin, logout: mParticleLogout } = useMParticleContext();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      launchDarklyLogin(currentUser);

      mParticleLogin({
        customerid: currentUser.thLegacyCognitoId
          ? `us-east-1:${currentUser.thLegacyCognitoId}`
          : currentUser.cognitoId,
        rbiCognitoId: currentUser.cognitoId,
        ...currentUser.details,
      });

      brazeSetUserId(
        currentUser.thLegacyCognitoId
          ? `us-east-1:${currentUser.thLegacyCognitoId}`
          : currentUser.cognitoId
      );

      // Update Braze Email for the user
      ReactAppboy.setEmail(currentUser.details.email);
    },
    [brazeSetUserId, launchDarklyLogin, mParticleLogin]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    launchDarklyLogout();
    mParticleLogout();
    brazeSetUserId(null);
  }, [brazeSetUserId, launchDarklyLogout, mParticleLogout]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
